import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "HR Manager, TechWoa Solutions",
    feedback:
      "JobsInDelhiNCR helped us fill 5 critical positions within just 10 days. The candidate quality was excellent!",
    img: "https://randomuser.me/api/portraits/men/12.jpg",
    alt: "rajesh",
  },
  {
    name: "Neha Malhotra",
    role: "Talent Acquisition Head, BrightMinda Consulting",
    feedback:
      "Posting jobs was seamless, and we received highly relevant applications within hours.",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
    alt: "neha",
  },
  {
    name: "Arjun Mehta",
    role: "Founder, StartupX",
    feedback:
      "As a startup, we needed affordable hiring solutions. This portal gave us great reach at minimal cost.",
    img: "https://randomuser.me/api/portraits/men/56.jpg",
    alt: "arjun",
  },
  {
    name: "Naman Arora",
    role: "Talent Acquisition Head,Bimla Soft",
    feedback: "Success starts with a great job. Come join us.",
    img: "https://randomuser.me/api/portraits/men/58.jpg",
    alt: "naman",
  },
];

export default function TestimonialSection() {
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: !isMobile, // disable autoplay on mobile
    speed: 800,
    autoplaySpeed: 4000,
    slidesToShow: isMobile ? 1 : 3, // 1 card in mobile, 3 in desktop
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="py-10 bg-gradient-to-r from-blue-50 to-blue-100 overflow-hidden">
      <h2 className="text-3xl font-bold text-center mb-8">
        What Recruiters Say About Us
      </h2>
      <Slider {...settings}>
        {testimonials.map((t, index) => (
          <motion.div
            key={index}
            className="px-4 overflow-hidden"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Tilt
              glareEnable={true}
              glareMaxOpacity={0.15}
              glareColor="#ffffff"
              tiltMaxAngleX={8}
              tiltMaxAngleY={8}
              perspective={1000}
              className="w-full"
            >
              <div className="bg-white shadow-lg rounded-xl p-6 text-center transform-gpu hover:shadow-2xl transition-all duration-500">
                <img
                  src={t.img}
                  alt={t.alt}
                  className="w-20 h-20 mx-auto rounded-full border-4 border-blue-500"
                />
                <p className="text-gray-600 italic mt-4">"{t.feedback}"</p>
                <h4 className="mt-4 font-semibold text-lg">{t.name}</h4>
                <span className="text-blue-500 text-sm">{t.role}</span>
              </div>
            </Tilt>
          </motion.div>
        ))}
      </Slider>
    </section>
  );
}
